import React, { useState, useEffect, useCallback } from 'react';

import { useGamerData } from '../hooks/useGamerData';

import { baseURL } from '../util/Constants.js';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { sizing } from '@material-ui/system';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
  }));
  
  

export default function GamerData(props) {
    

    const [ethAddress, setEthAddress] = useState(null);
    const [gamerNameValue, setGamerNameValue] = useState("");
    const [fortniteNameValue, setFortniteNameValue] = useState("");

    const [status, setStatus] = useState(null);

    const gamerData = useGamerData(props.address);

    const classes = useStyles();

    useEffect(() => {
        if(props.address !== ethAddress){
        setEthAddress(props.address);
        }
    },[props.address])

    useEffect(() => {
        console.log(gamerData);
    },[gamerData])

    const setGamerName =  (name) => {

        setStatus(`Attempting Set Gamer Name.. ${name}`);

        let postData = {
            gamerName: name,
            address: ethAddress,
        }
    
        let fetchURL = `${baseURL}/setGamerName`;

        console.log(`Post Data:`, postData);
    
        fetch(fetchURL,
            {
                method: 'POST',
                body: JSON.stringify(postData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        .then((res) => {

            

            let retData = res.json();
    
            console.log(retData);
    
            retData.then((data) => {

                setStatus(`Gamer name set to ${data.gamerName}`);

                console.log('Inside ');
                console.log(data);
    
            })
    
        })
    
    }

    const setFortniteName =  (name) => {

        setStatus(`Attempting Set Fortnite Name.. ${name}`);

        let postData = {
            fortniteName: name,
            address: ethAddress,
        }
    
        let fetchURL = `https://us-central1-gameforcrypto.cloudfunctions.net/setFortniteName`;

        console.log(`Post Data:`, postData);
    
        fetch(fetchURL,
            {
                method: 'POST',
                body: JSON.stringify(postData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        .then((res) => {

            let retData = res.json();
    
            console.log(retData);
    
            retData.then((data) => {

                setStatus(`Fortnite name set to ${data.fortniteName}`);

                console.log('Inside ');
                console.log(data);
    
            })
    
        })
    
    }

    const displayGamerData = () => {
        let display = null;
        let displayGamerName = null;
        let displayFortniteName = null;
        let displayPlayerHash = null;

        if(ethAddress !== null){

            if(gamerData.hasLoaded){
                if(gamerData.hasGamerName){
                displayGamerName = (
                    <React.Fragment>
                        <Typography variant="h5" className={classes.title}
                        style={{ marginTop: 32 }}
                        >
                            Gamer Name: {gamerData.hasGamerName}
                            </Typography>
                    </React.Fragment>
                )

                displayPlayerHash = (
                    <React.Fragment>
                    <TextField type={'text'} 
                    style={{ margin: 16, width: '90%' }} 
                    label={`Player Hash`}value={gamerData.data.playerHash} onChange={(event) => {
                        navigator.clipboard.writeText(gamerData.data.playerHash);
                        setStatus('Player Hash Copied To Clipboard');
                    }} />
                    </React.Fragment>
                )
                
                if(gamerData.data.fortniteName) {
                    displayFortniteName = (
                        <React.Fragment>
                            <Typography variant="h6" className={classes.title}
                            style={{ marginTop: 32 }}
                            >
                            Fortnite Name:{gamerData.data.fortniteName}
                            </Typography>
                        </React.Fragment>
                    )
                } else {
                    displayFortniteName = (
                        <div>
                            <TextField type={'text'} label={`Link Your Fortnite Name`} 
                                style={{ margin: 16, width: '70%' }}
                                margin="normal" value={fortniteNameValue} onChange={(event) => {
                                    setFortniteNameValue(event.target.value);
                                }} />
                            
                                <Button
                                style={{ marginTop: 32, width: '10%' }}
                                onClick={() => {
                                    if(fortniteNameValue !== ""){
                                        setFortniteName(fortniteNameValue);
                                    }
                                }}> Set! </Button>
                        </div>
                    )
                }


                

                } else {
                    displayGamerName = (
                        <Grid container>
                            <Grid item xs={9}>
                                <TextField type={'text'} label={`Choose Gamer Name`} 
                                style={{ margin: 16 }}
                                fullWidth
                                helperText={`32 Characters Max`}
                                margin="normal" value={gamerNameValue} onChange={(event) => {
                                    setGamerNameValue(event.target.value);
                                }} />
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                variant="outlined"
                                style={{ margin: 32 }}
                                width={'90%'}
                                onClick={() => {
                                    if(gamerNameValue !== ""){
                                        setGamerName(gamerNameValue);
                                    }
                                }}
                                > Check For Availability </Button>
                            </Grid>
                            
                        </Grid>
                    )
                }
            }

            display = (
                <Paper elevation={3} width={'100%'} style={{marginTop: 8, marginLeft: 14, marginRight: 14}}>
                    {/*<Typography variant="h6" className={classes.title}>
                    Gamer Eth Address: {ethAddress}
                    </Typography>*/}

                    <Grid container width={'100%'}>

                        <Grid item xs>
                        {displayGamerName}
                        </Grid>

                        {gamerData.hasGamerName &&
                        <React.Fragment>
                        <Grid item xs>
                        {displayFortniteName}
                        </Grid>
                        <Grid item xs>
                        {displayPlayerHash}
                        </Grid>
                        </React.Fragment>
                        }
                    </Grid>
                </Paper>
            )
        }

        return display;

    }

    return (
        <React.Fragment>
            {status &&
            <p>{status}</p>
            }
            {displayGamerData()}
        </React.Fragment>
    )

}